let capturedElements = [];
let popUps = [];

export class PopUp {
    constructor(controller) {
        this.controller = controller;
        this.popup = document.getElementById(this.controller.getAttribute('aria-controls'));
        this.isOpened = false;

        this.init();
    }

    init = () => {
        this.controller.addEventListener('click', this.clickHandler);
        this.popup.addEventListener('keydown', this.keydownHandler);
    }

    open = () => {
        this.controller.setAttribute('aria-expanded', 'true');
        this.popup.setAttribute('data-state', 'open');
        this.isOpened = true;

        document.body.addEventListener('click', this.bodyClickHandler)
    }
    
    close = () => {
        this.controller.setAttribute('aria-expanded', 'false');
        this.popup.setAttribute('data-state', 'closed');
        this.isOpened = false;

        document.body.removeEventListener('click', this.bodyClickHandler);
    }

    clickHandler = (e) => {
        e.preventDefault();

        if (this.isOpened) {
            this.close();
        } else {
            this.open();
        }
    }

    bodyClickHandler = (e) => {
        const controllerClicked = e.target.closest('[aria-controls]') === this.controller;
        const popupClicked = e.target.closest(`#${this.popup.id}`) === this.popup;

        if (!controllerClicked && !popupClicked) this.close();
    }

    keydownHandler = (e) => {
        switch(e.key) {
            case 'Escape':
                this.close();
                this.controller.focus();
        }
    }
}

export const addPopUp = (controller) => {
    const popup = new PopUp(controller);

    popUps.push(popup);

    return popup;
};

export default init = (target = document) => {
    const targetElements = [...target.querySelectorAll('button[aria-expanded][aria-controls]')];
    const dedupedTargetElements = targetElements.filter(targetElement => !capturedElements.find(capturedElement => targetElement === capturedElement));

    if (dedupedTargetElements.length === 0) return;

    dedupedTargetElements.forEach(element => {
        capturedElements.push(element);
        popUps.push(new PopUp(element));
    });
}